const ar = {
  // Legacy key aliases
  add: 'إضافة', edit: 'تعديل', save: 'حفظ', cancel: 'إلغاء', delete: 'حذف',
  search: 'بحث', export: 'تصدير', download: 'تحميل', signIn: 'تسجيل الدخول',
  chassis: 'رقم الهيكل', make: 'الشركة المصنعة', model: 'الموديل', year: 'السنة', color: 'اللون',
  mileage: 'المسافة المقطوعة', displacement: 'سعة المحرك', transmission: 'ناقل الحركة',
  port: 'الميناء', status: 'الوضع', price: 'السعر', cost: 'التكلفة', fobPrice: 'سعر FOB',
  condition: 'الحالة', quantity: 'الكمية', category: 'الفئة', fitment: 'التوافق',
  cutType: 'نوع القطع', sku: 'رمز المنتج', name: 'الاسم', email: 'البريد الإلكتروني',
  password: 'كلمة المرور', phone: 'الهاتف', company: 'الشركة', country: 'البلد',
  scan: 'مسح QR',
  priceQuotes: 'عروض الأسعار',
  selectionOrders: 'أوامر الاختيار',
  pricing: 'التسعير',
  vehicles: 'المركبات', engines: 'المحركات', parts: 'قطع الغيار', containers: 'الحاويات',
  customers: 'العملاء', requests: 'الطلبات', employees: 'الموظفين', settings: 'الإعدادات',
  dashboard: 'لوحة التحكم', inventory: 'المخزون', myStock: 'مخزوني',
  invoices: 'الفواتير', payments: 'المدفوعات', noData: 'لا توجد بيانات',
  loading: 'جاري التحميل...', totalUnits: 'إجمالي الوحدات', printQR: 'طباعة QR',
  whatsAppInquiry: 'استفسار واتساب', viewDetails: 'عرض التفاصيل',
  staffPortal: 'بوابة الموظفين', customerPortal: 'بوابة العملاء',
  invalidCredentials: 'بيانات الدخول غير صحيحة',

  // Dashboard - additional
  dash_good_morning: 'صباح الخير',
  dash_good_afternoon: 'مساء الخير',
  dash_good_evening: 'مساء الخير',
  dash_financial_overview: 'نظرة مالية عامة',
  dash_units_in_account: 'وحدات في حسابك',
  dash_my_shipments: 'شحناتي',
  dash_on_the_way: 'في الطريق',
  dash_arrived: 'وصلت',
  dash_no_shipments: 'لا توجد شحنات نشطة',
  dash_recommended: 'موصى به لك',
  dash_available_units: 'الوحدات المتاحة',
  dash_no_available: 'لا توجد وحدات متاحة حالياً.',
  dash_total_fob: 'إجمالي قيمة FOB',
  dash_late_night: 'وقت متأخر',
  dash_hello: 'مرحباً',
  dash_subtitle: 'نظرة عامة على أسطولك وقطع الغيار والشحنات الواردة — يتم التحديث في الوقت الفعلي.',
  dash_local_time: 'التوقيت المحلي',
  dash_status: 'الحالة',
  dash_all_systems_live: 'جميع الأنظمة تعمل',
  dash_view_recommendations: 'عرض التوصيات',
  dash_my_stock: 'مخزوني',
  dash_in_transit: 'في الطريق',
  dash_units: 'وحدات',
  dash_containers: 'حاويات',
  dash_browse_more: 'تصفح المزيد',
  dash_track_shipments: 'تتبع الشحنات',
  dash_browse_inventory_start: 'تصفح المخزون للبدء',
  dash_no_active_shipments: 'لا توجد شحنات نشطة',
  dash_next_eta: 'الوصول المتوقع خلال',
  dash_days: 'أيام',
  dash_etas_confirming: 'يتم تأكيد مواعيد الوصول',
  dash_this_week: 'هذا الأسبوع',
  dash_arriving_soon: 'وصول قريب',
  dash_logistics: 'اللوجستيات',
  dash_active_shipments: 'الشحنات النشطة',
  dash_view_all: 'عرض الكل',
  dash_shipment_empty: 'ستظهر شحنتك القادمة هنا عند تحميل الوحدات في حاوية',
  dash_composition: 'التركيب',
  dash_stock_breakdown: 'تفصيل المخزون',
  dash_no_units_yet: 'لا توجد وحدات بعد',
  dash_browse_to_build: 'ابدأ بتصفح المخزون لبناء مخزونك',
  dash_for_you: 'لك',
  dash_picked_based: 'مختار بناءً على مخزونك',
  dash_browse_all: 'تصفح الكل',
  dash_picking_units: 'نقوم باختيار وحدات لك. تحقق مرة أخرى قريباً',
  dash_view_details: 'عرض التفاصيل',
  dash_just_arrived: 'وصل حديثاً',
  dash_similar: 'مشابه لمخزونك',
  dash_today: 'اليوم',
  dash_tomorrow: 'غداً',
  dash_total_cost: 'إجمالي التكلفة',
  dash_gross_margin: 'هامش الربح الإجمالي',
  dash_awaiting_pricing: 'بانتظار التسعير',
  dash_vehicle_fob: 'إجمالي FOB المركبات',
  dash_engine_fob: 'إجمالي FOB المحركات',
  dash_parts_fob: 'إجمالي FOB القطع',
  dash_total_freight: 'إجمالي تكلفة الشحن',
  dash_fob_by_make: 'قيمة FOB حسب الشركة',
  dash_no_priced_vehicles: 'لا توجد مركبات مسعرة',
  dash_top_units: 'أعلى 5 وحدات حسب FOB',
  dash_no_priced_units: 'لا توجد وحدات مسعرة',
  dash_margin: 'هامش',
  dash_container_breakdown: 'التفصيل المالي للحاويات',
  dash_no_containers: 'لا توجد حاويات',
  dash_container: 'الحاوية',
  dash_route: 'المسار',
  dash_units: 'الوحدات',
  dash_freight_cost: 'تكلفة الشحن',
  dash_fob_value: 'قيمة FOB',
  dash_net_after_freight: 'الصافي بعد الشحن',
  dash_receivables: 'المستحقات',
  dash_total: 'الإجمالي',
  dash_current: 'الحالي',
  dash_overdue: 'متأخر',
  dash_oldest: 'الأقدم',
  dash_days: 'أيام',
  dash_this_month: 'هذا الشهر',
  dash_invoiced: 'تم الفوترة',
  dash_received: 'تم الاستلام',
  dash_avg_margin: 'متوسط الهامش',
  dash_quotes_sent: 'عروض مرسلة',
  dash_pending_actions: 'إجراءات معلقة',
  dash_receipts_verify: 'إيصالات دفع تحتاج تحقق',
  dash_units_pricing: 'وحدات تحتاج تسعير',
  dash_invoices_overdue: 'فواتير متأخرة',
  dash_customer_balances: 'أرصدة العملاء',
  dash_customer_overview: 'نظرة عامة على العملاء',
  dash_top_customers: 'أفضل العملاء (حسب الإيرادات)',
  dash_attention: 'تنبيه',
  dash_no_customer_data: 'لا توجد بيانات عملاء.',
  dash_no_customers: 'لا يوجد عملاء',
  dash_no_activity: 'لا يوجد نشاط حديث',
  dash_price_quotes: 'عروض الأسعار',
  dash_pending: 'قيد الانتظار',
  dash_in_progress: 'قيد التنفيذ',
  dash_quoted_week: 'مسعر هذا الأسبوع',
  recentActivity: 'النشاط الأخير',
  inventoryValue: 'قيمة المخزون',
  inTransit: 'في الطريق',
  pendingRequests: 'طلبات معلقة',

  // Navigation
  nav_dashboard: 'لوحة التحكم',
  nav_inventory: 'المخزون',
  nav_my_stock: 'مخزوني',
  nav_my_selection: 'اختياراتي',
  nav_containers: 'الحاويات',
  nav_requests: 'الطلبات',
  nav_invoices: 'الفواتير',
  nav_payments: 'المدفوعات',
  nav_customers: 'العملاء',
  nav_employees: 'الموظفون',
  nav_settings: 'الإعدادات',
  nav_pricing: 'التسعير',
  nav_price_quotes: 'عروض الأسعار',
  nav_selection_orders: 'أوامر الاختيار',
  nav_tasks: 'المهام',
  nav_scan: 'ماسح QR',
  nav_cut_plans: 'خطط القطع',
  nav_market_prices: 'أسعار السوق',
  nav_sign_out: 'تسجيل الخروج',

  // Common actions
  btn_save: 'حفظ',
  btn_cancel: 'إلغاء',
  btn_delete: 'حذف',
  btn_edit: 'تعديل',
  btn_add: 'إضافة',
  btn_submit: 'إرسال',
  btn_approve: 'موافقة',
  btn_reject: 'رفض',
  btn_download: 'تحميل',
  btn_upload: 'رفع',
  btn_search: 'بحث',
  btn_export: 'تصدير',
  btn_clear: 'مسح',
  btn_confirm: 'تأكيد',
  btn_close: 'إغلاق',
  btn_view: 'عرض',
  btn_remove: 'إزالة',
  btn_back: 'رجوع',
  btn_next: 'التالي',
  btn_save_changes: 'حفظ التغييرات',
  btn_sign_in: 'تسجيل الدخول',
  btn_contact_us: 'اتصل بنا',

  // Login
  login_title: 'بيج ستار',
  login_subtitle: 'نظام إدارة تصدير السيارات',
  login_staff_portal: 'بوابة الموظفين',
  login_customer_portal: 'بوابة العملاء',
  login_username: 'اسم المستخدم',
  login_email: 'البريد الإلكتروني',
  login_password: 'كلمة المرور',
  login_remember: 'تذكرني',
  login_invalid: 'بيانات الاعتماد غير صالحة',
  login_frozen: 'تم تجميد حسابك. يرجى الاتصال بالمسؤول.',
  login_blocked: 'تم تعليق حسابك. يرجى الاتصال بالدعم.',
  login_timeout: 'انتهت جلستك بسبب عدم النشاط. يرجى تسجيل الدخول مرة أخرى.',

  // Inventory
  inv_add_to_stock: 'أضف إلى مخزوني',
  inv_in_stock: 'في مخزوني',
  inv_reserved: 'محجوز',
  inv_sold: 'مباع',
  inv_available: 'متاح',
  inv_search_placeholder: 'البحث عن سيارات، قطع غيار، محركات...',
  inv_no_results: 'لم يتم العثور على عناصر',
  inv_vehicle: 'مركبة',
  inv_engine: 'محرك',
  inv_spare_part: 'قطعة غيار',
  inv_vehicles: 'المركبات',
  inv_engines: 'المحركات',
  inv_parts: 'قطع الغيار',
  inv_all: 'الكل',
  inv_add_vehicle: 'إضافة مركبة',
  inv_add_engine: 'إضافة محرك',
  inv_add_part: 'إضافة قطعة غيار',
  inv_total_units: 'إجمالي الوحدات',
  inv_no_data: 'لا توجد بيانات متاحة',
  inv_per_page: 'في الصفحة',
  inv_page: 'صفحة',
  inv_of: 'من',

  // Vehicle details
  detail_make: 'الشركة المصنعة',
  detail_model: 'الموديل',
  detail_year: 'السنة',
  detail_chassis: 'رقم الهيكل',
  detail_color: 'اللون',
  detail_mileage: 'المسافة المقطوعة',
  detail_grade: 'الدرجة',
  detail_score: 'النتيجة',
  detail_engine_code: 'رمز المحرك',
  detail_transmission: 'ناقل الحركة',
  detail_fuel: 'نوع الوقود',
  detail_steering: 'نوع المقود',
  detail_drive: 'نظام الدفع',
  detail_condition: 'الحالة',
  detail_status: 'الوضع',
  detail_price: 'السعر',
  detail_fob: 'سعر FOB',
  detail_chassis_number: 'رقم الشاسيه',
  detail_displacement: 'سعة المحرك',
  detail_port: 'الميناء',
  detail_city: 'المدينة',
  detail_seats: 'المقاعد',
  detail_category: 'الفئة',
  detail_fitment: 'التوافق',
  detail_quantity: 'الكمية',
  detail_sku: 'رمز المنتج',
  detail_cut_type: 'نوع القطع',
  detail_photos: 'الصور',
  detail_notes: 'ملاحظات',

  // Statuses
  status_available: 'متاح',
  status_assigned: 'مخصص',
  status_sold: 'مباع',
  status_shipped: 'تم الشحن',
  status_in_transit: 'في الطريق',
  status_at_port: 'في الميناء',
  status_customs: 'جمارك',
  status_delivered: 'تم التسليم',
  status_japan_yard: 'ساحة اليابان',
  status_loading: 'جاري التحميل',
  status_loaded: 'تم التحميل',
  status_pending: 'قيد الانتظار',
  status_approved: 'تمت الموافقة',
  status_rejected: 'مرفوض',
  status_planning: 'تخطيط',
  status_booked: 'محجوز',
  status_sealed: 'مختوم',
  status_closed: 'مغلق',

  // My Stock
  stock_title: 'مخزوني',
  stock_available_section: 'الوحدات المتاحة',
  stock_in_review: 'قيد المراجعة',
  stock_approved_section: 'تمت الموافقة',
  stock_empty: 'مخزونك فارغ. تصفح المخزون لإضافة وحدات.',
  stock_remove_confirm: 'إزالة هذه الوحدة من مخزونك؟',
  stock_remove_note: 'ستصبح متاحة للمشترين الآخرين.',
  stock_request_quote: 'طلب عرض سعر',
  stock_quote_requested: 'تم طلب عرض السعر',
  stock_price_pending: 'السعر: قيد الانتظار',
  stock_my_orders: 'طلباتي',

  // Selection
  sel_units_selected: '{count} وحدات مختارة',
  sel_total: 'الإجمالي',
  sel_continue: 'متابعة',
  sel_submit: 'إرسال الاختيار النهائي',
  sel_review_title: 'مراجعة اختيارك',
  sel_review_subtitle: 'راجع وحداتك قبل الإرسال للموافقة',
  sel_notes_placeholder: 'أضف أي ملاحظات أو طلبات خاصة...',
  sel_submit_confirm: 'أنت على وشك إرسال {count} وحدة للموافقة. بمجرد الإرسال، سيتم حجز هذه الوحدات. متابعة؟',
  sel_submitted: 'تم إرسال اختيارك للمراجعة!',
  sel_orders_title: 'طلبات الاختيار الخاصة بي',
  sel_no_orders: 'لا توجد طلبات بعد.',

  // Containers
  cont_title: 'الحاويات',
  cont_no_containers: 'لا توجد حاويات بعد. ستظهر وحداتك هنا بمجرد تحميلها للشحن.',
  cont_destination: 'الوجهة',
  cont_eta: 'الوصول المتوقع',
  cont_units_inside: 'الوحدات في هذه الحاوية',
  cont_seal: 'رقم الختم',
  cont_timeline: 'الجدول الزمني',
  cont_download_bl: 'تحميل بوليصة الشحن',
  cont_payment_required: 'أكمل الدفع لاستلام بوليصة الشحن',
  cont_bl_processing: 'جاري تسليم بوليصة الشحن',
  cont_arrived: 'وصلت الحاوية',
  cont_mark_received: 'تأكيد الاستلام',
  cont_new: 'حاوية جديدة',
  cont_start_loading: 'بدء التحميل',
  cont_mark_loaded: 'تأكيد التحميل',
  cont_complete_loading: 'إكمال التحميل',
  cont_add_update: 'إضافة تحديث',

  // Invoices
  invoice_title: 'الفواتير',
  invoice_action_required: 'إجراء مطلوب',
  invoice_completed: 'مكتملة',
  invoice_payment_history: 'سجل المدفوعات',
  invoice_total_invoiced: 'إجمالي الفواتير',
  invoice_total_paid: 'المدفوع',
  invoice_outstanding: 'المستحق',
  invoice_overdue: 'متأخر',
  invoice_upload_receipt: 'رفع الإيصال',
  invoice_download_pdf: 'تحميل PDF',
  invoice_payment_due: 'موعد الدفع',
  invoice_days_overdue: '{days} أيام متأخرة',
  invoice_fully_paid: 'مدفوع بالكامل',
  invoice_proforma: 'فاتورة مبدئية',
  invoice_view_details: 'عرض التفاصيل',

  // Condition
  cond_good: 'جيد',
  cond_minor_damage: 'ضرر طفيف',
  cond_major_damage: 'ضرر كبير',
  cond_missing_parts: 'أجزاء مفقودة',

  // Dashboard
  dash_welcome: 'مرحباً، {name}',
  dash_total_units: 'إجمالي الوحدات',
  dash_inventory_value: 'قيمة المخزون',
  dash_in_transit: 'في الطريق',
  dash_pending_requests: 'طلبات معلقة',

  // Settings
  settings_title: 'الإعدادات',
  settings_profile: 'ملفي الشخصي',
  settings_name: 'الاسم',
  settings_phone: 'الهاتف',
  settings_new_password: 'كلمة مرور جديدة',
  settings_keep_current: 'اتركها فارغة للإبقاء على الحالية',

  // Notifications
  notif_title: 'الإشعارات',
  notif_mark_read: 'تحديد كمقروء',
  notif_no_new: 'لا توجد إشعارات جديدة',

  // Payments page
  pay_title: 'المدفوعات',
  pay_verified: 'المدفوعات المتحققة',
  pay_no_verified: 'لا توجد مدفوعات متحققة بعد.',
  pay_add: 'إضافة دفعة',
  pay_outgoing: 'المدفوعات الصادرة',
  pay_no_outgoing: 'لا توجد مدفوعات صادرة مسجلة.',
  pay_export_csv: 'تصدير CSV',
  pay_verify: 'تحقق',
  pay_reject: 'رفض',
  pay_view_receipt: 'عرض الإيصال',
  pay_view_invoice: 'عرض الفاتورة',
  pay_amount: 'المبلغ',
  pay_method: 'الطريقة',
  pay_date: 'التاريخ',
  pay_reference: 'المرجع',

  // Invoices - additional
  invoice_no_invoices: 'لا توجد فواتير',
  invoice_empty_msg: 'ستظهر الفواتير هنا عند إنشائها.',
  invoice_all_customers: 'جميع العملاء',
  invoice_send: 'إرسال للعميل',
  invoice_save_draft: 'حفظ المسودة',
  invoice_line_items: 'بنود الفاتورة',
  invoice_subtotal: 'المجموع الفرعي',
  invoice_fees: 'الرسوم',
  invoice_grand_total: 'المجموع الإجمالي',
  invoice_milestones: 'مراحل الدفع',

  // Selection Orders
  selorder_title: 'أوامر الاختيار',
  selorder_no_orders: 'لا توجد أوامر اختيار',
  selorder_empty_msg: 'ستظهر أوامر اختيار العملاء هنا عند تقديمها.',
  selorder_approve: 'موافقة',
  selorder_reject: 'رفض',
  selorder_units: 'الوحدات',
  selorder_customer: 'العميل',
  selorder_status: 'الحالة',
  selorder_submitted: 'تم التقديم',

  // Containers - additional
  cont_new_container: 'حاوية جديدة',
  cont_freight: 'الشحن',
  cont_search_placeholder: 'بحث حاوية، سفينة، ختم',
  cont_in_transit: 'في الطريق',
  cont_loading: 'جاري التحميل',
  cont_origin: 'المنشأ',
  cont_vessel: 'السفينة',
  cont_voyage: 'الرحلة',
  cont_size: 'الحجم',
  cont_status: 'الحالة',
  cont_units_count: 'الوحدات',
  cont_planned_departure: 'المغادرة المخططة',
  cont_actual_departure: 'المغادرة الفعلية',

  // Requests - additional
  req_title: 'الطلبات',
  req_new: 'طلب جديد',
  req_reply: 'رد',
  req_view: 'عرض',
  req_pending: 'قيد الانتظار',
  req_processing: 'قيد المعالجة',
  req_sourced: 'تم التوفير',
  req_cancelled: 'ملغى',
  req_budget: 'الميزانية',
  req_type_vehicle: 'مركبة',
  req_type_engine: 'محرك',
  req_type_part: 'قطعة غيار',

  // Common UI
  ui_all_customers: 'جميع العملاء',
  ui_export_csv: 'تصدير CSV',
  ui_no_data: 'لا توجد بيانات',
  ui_show: 'عرض',
  ui_per_page: 'في الصفحة',
  ui_page: 'صفحة',
  ui_of: 'من',
  ui_edit: 'تعديل',
  ui_delete: 'حذف',
  ui_download: 'تحميل',
  ui_new: 'جديد',
  ui_reply: 'رد',

  // Detail - additional labels
  detail_location: 'الموقع',
  detail_manufacturer: 'المصنع',
  detail_assign_customer: 'تعيين للعميل',
  detail_assigned_to: 'مخصص لـ',
  detail_not_assigned: 'غير مخصص',
  detail_unassign: 'إلغاء التعيين',
  detail_no_notes: 'لا توجد ملاحظات',
  detail_request_parts: 'طلب قطع غيار من هذه المركبة',
  detail_arrived_yard: 'وصلت إلى ساحتك',
  detail_return_stock: 'إلغاء / إرجاع للمخزون',
  detail_download_photos: 'تحميل الصور',

  // Inventory - filters
  inv_all_items: 'جميع العناصر',
  inv_all_status: 'جميع الحالات',
  inv_all_makes: 'جميع الشركات',
  inv_all_years: 'جميع السنوات',
  inv_all_transmissions: 'جميع ناقلات الحركة',
  inv_all_conditions: 'جميع الحالات',
  inv_all_categories: 'جميع الفئات',
  inv_all_countries: 'جميع الدول',
  inv_item: 'العنصر',
  inv_details: 'التفاصيل',
  inv_days: 'الأيام',
  inv_show: 'عرض',
  inv_request_parts: 'طلب قطع غيار',
  inv_how_want_vehicle: 'كيف تريد هذه المركبة؟',
  inv_full_vehicle: 'مركبة كاملة',
  inv_full_vehicle_desc: 'المركبة كاملة كما هي',
  inv_custom: 'مخصص',
  inv_custom_desc: 'صف طلبك',
  inv_newest: 'الأحدث أولاً',
  inv_oldest: 'الأقدم أولاً',
  inv_price_high: 'السعر: من الأعلى للأقل',
  inv_price_low: 'السعر: من الأقل للأعلى',
  inv_days_desc: 'أيام في المخزون',

  // Misc
  misc_all_customers: 'جميع العملاء',
  misc_viewing: 'عرض',
  misc_clear_filter: 'مسح الفلتر',
  misc_no_data: 'لا توجد بيانات',
  misc_loading: 'جاري التحميل...',
  misc_country: 'الدولة',
  misc_currency: 'العملة',
  misc_cost_summary: 'ملخص التكلفة',
  misc_total_fob: 'إجمالي FOB',
  misc_yes: 'نعم',
  misc_no: 'لا',
};

export default ar;
